import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnclientService } from './../../../../core/services/esnclient/esnclient.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SortDataService } from './../../../../core/services/sortdata';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-prestation-clients',
  templateUrl: './prestation-clients.component.html',
  styleUrls: ['./prestation-clients.component.css'],
})
export class PrestationClientsComponent {
  id: any;
  listprestation: any;
  totalItems!: number;
  searchElement: string = '';
  membres: any;
  listresponsables: any;
  membreslist: any = [];
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  pagination : boolean =false;

  startIndex: number = 0;
  endIndex: number = 5;
  formprojet!: FormGroup;
  sortAttr = '';
  private unsubscribeAll: Subject<void> = new Subject();
  searchForm: FormGroup = this.createSearchForm();
  currentSortColumn: string = 'name'; // Initial column to sort by

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private esnclientservice: EsnclientService,
    private sortDataService: SortDataService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.getlistprestation();
  }

  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.sortAttr = item;

    this.currentPage = 1;
    this.endIndex = 5;
    if (this.searchForm.dirty)
      this.listprestation = this.sortDataService.sortArray(
        this.listprestation,
        item,
        this.currentSortDirection
      );
    else this.getlistprestation();
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true
          this.getlistprestation();

        }
    }
  }

  getlistprestation() {
    this.id = this.localStorageService.getData('clientConnected');
    let dataPyload =
      this.sortAttr == ''
        ? {
            esn_id: this.id,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              esn_id: this.id,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };

    this.spinner.show();
    this.esnclientservice.getListprestation(dataPyload).subscribe({
      next: (response) => {
        if (response.data && response.data.data) {
          this.spinner.hide();
          this.listprestation = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
        }
      },
      error: (error) => {
        this.spinner.hide();
      },
    });
  }

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      search: [data ? data.search : ''],
    });
  }
  applyFilter(pageNumber : number = this.currentPage) {
    // let filterValue = (event?.target as HTMLInputElement)?.value;
    let data = {
      per_page: this.itemsPerPage,
      page: pageNumber,
      sort: this.currentSortDirection,
      search: this.searchElement,
      esn_id: this.localStorageService.getData('clientConnected'),
      sortAttribute: 'name',
    };
    this.spinner.show();
    this.esnclientservice
      .searchprestation(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (resSearch) => {
          if(this.startSearching == true) {
            this.currentPage = 1;
            this.startSearching = false;
          }    
          this.listprestation = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  reset() {
    this.searchForm.reset();

    this.applyFilter();
  }
}
